module.exports = __webpack_public_path__ + "static/media/img_snake_end_bottom.f6fb50c7.svg";